import { Input as BriqCommonInput } from '@briq/shared'

export type InputProps = BriqCommonInput.InputProps

export const Input = BriqCommonInput.Input
